<template>
  <div class="release-demand-container">
    <com-header></com-header>
    <div class="crumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          :to="{
            path: '/demandHall',
            query: { name: demandType[activeIndex].title }
          }"
        >
          需求大厅
        </el-breadcrumb-item>
        <el-breadcrumb-item>发布需求</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="demand-info">
      <ul class="headline">
        <li
          v-for="(item, index) in demandType"
          :key="index"
          :class="['demand-type', activeIndex === index ? 'active' : '']"
          @click="handleClick(index)"
        >
          {{ item.title }}
        </li>
      </ul>
      <div class="demand-form">
        <router-view />
      </div>
    </div>
    <home-service></home-service>
    <com-footer></com-footer>
    <!-- 需求显示确认弹框弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      class="demandPopup"
      :close-on-click-modal="false"
    >
      <p class="tCenter">
        提交成功
      </p>
      <div class="one font18 fontW">
        您的需求已提交成功，平台会在1-3个工作日后审核
      </div>

      <div class="btn_group tCenter">
        <el-button class="btn_sure" @click="toDemandHall">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import homeService from '../../components/HomeService.vue'

export default {
  name: 'ReleaseDemand',
  components: {
    homeService
  },
  data() {
    return {
      activeIndex: 0,
      dialogVisible: false
    }
  },
  computed: {
    ...mapState({
      demandType: state => state.demand.demandType
    })
  },
  created() {
    this.findActive()
  },
  methods: {
    findActive() {
      this.demandType.map((item, index) => {
        if (this.$route.fullPath.indexOf(item.name) > 0) {
          this.activeIndex = index
        }
      })
    },
    handleClick(index) {
      this.activeIndex = index
      this.$router.push({
        path: this.demandType[index].name
      })
    },
    toDemandHall() {
      this.$router.push({
        path: '/demandHall2',
        query: {
          name: this.demandType[this.activeIndex].name
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.release-demand-container {
  background: #f8f8f8;
  .crumb {
    width: 1200px;
    height: 82px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .demand-info {
    width: 1200px;
    margin: 0 auto;
    background: #ffffff;
    margin-bottom: 71px;

    ul.headline {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      border-bottom: 1px solid #e4e4e4;
      li.demand-type {
        font-size: 16px;
        font-weight: bold;
        color: #ce2939;
        line-height: 22px;
        padding: 4px 20px;
        cursor: pointer;
      }
      li.active {
        // font-size: 18px;
        background: #ce2939;
        color: #ffffff;
      }
    }
    .demand-form {
      padding: 20px;
      width: 680px;
      margin: 0 auto;
      margin-left: 20%;
    }
  }
}
</style>

<style lang="scss">
.release-demand-container {
  .el-breadcrumb__inner {
    color: #666666;
    &:hover {
      color: #ce2939;
    }
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #ce2939;
  }
}
</style>
